import moment from "moment";
import React from "react";

const Columns = ({ handleViewHandler } = {}) => [
  {
    dataField: "date",
    text: "Date",
    formatter: (cell) => (cell ? moment(cell).format("DD MMM YYYY") : "-"),
  },
  {
    dataField: "status",
    text: "Status",
    formatter: (cell) => {
      const statusColors = {
        success: "badge badge-success",
        partial: "badge badge-warning",
        failed: "badge badge-danger",
        pending: "badge badge-secondary",
      };
      return cell ? (
        <span className={statusColors[cell] || "badge badge-secondary"}>
          {cell.charAt(0).toUpperCase() + cell.slice(1)}
        </span>
      ) : (
        "-"
      );
    },
  },
  {
    dataField: "adminDetails.email",
    text: "Admin Email",
    formatter: (cell) => {
      return cell ? <span className={""}>{cell}</span> : "-";
    },
  },
  {
    dataField: "adminDetails.name",
    text: "Admin Name",
    formatter: (cell) => {
      return cell ? <span className={""}>{cell}</span> : "-";
    },
  },
  {
    dataField: "createdAt",
    text: "Created At",
    formatter: (cell) =>
      cell ? moment(cell).format("DD MMM YYYY, hh:mm A") : "-",
  },
  {
    dataField: "_id",
    text: "Action",
    formatter: (cell, row) => (
      <>
        <button
          className="fas fa-eye bg-white border-0"
          title="view"
          style={{ fontSize: " 16px" }}
          onClick={() => handleViewHandler && handleViewHandler(row)}
        ></button>
        {/* <button className="btn btn-primary btn-sm">View</button> */}
      </>
    ),
  },
];

export default Columns;
